import React, { useEffect, useState } from 'react';
import { ArrowRight, ChevronDown, Award } from 'lucide-react';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const scrollToSimulator = () => {
    const el = document.querySelector('#simulador');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="inicio" className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=1920&q=80')`,
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/80 via-[#0a0a0a]/70 to-[#0a0a0a]/90" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        {/* Badge */}
        <div
          className={`mb-6 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="inline-flex items-center gap-2 bg-[#8B6F47]/20 border border-[#8B6F47]/40 rounded-full px-5 py-2 mb-6">
            <Award className="w-4 h-4 text-[#C9A961]" />
            <span className="font-body text-sm tracking-wider text-[#D4B483] font-medium">
              +30 anos de experiência
            </span>
          </div>
          <div className="w-12 h-[2px] bg-gradient-to-r from-[#8B6F47] to-[#C9A961] mx-auto mb-4" />
        </div>

        <h1
          className={`font-display text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Transforme seu evento em uma{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8B6F47] to-[#D4B483]">
            experiência inesquecível
          </span>
        </h1>

        <p
          className={`font-body text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto transition-all duration-1000 delay-[400ms] ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Há mais de 30 anos criando momentos únicos com buffet, drinks e estrutura completa
        </p>

        <div
          className={`flex flex-col sm:flex-row gap-4 justify-center mb-12 transition-all duration-1000 delay-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <button
            onClick={scrollToSimulator}
            data-testid="hero-cta-simulador"
            className="group flex items-center justify-center gap-2 bg-gradient-to-r from-[#8B6F47] to-[#C9A961] text-white font-body font-semibold text-sm tracking-[0.15em] uppercase px-10 py-4 rounded-sm hover:shadow-xl hover:shadow-[#8B6F47]/40 hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300"
          >
            Monte seu evento personalizado
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="https://wa.me/5531999172997"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-whatsapp"
            className="flex items-center justify-center gap-2 border border-white/30 text-white font-body text-sm tracking-[0.15em] uppercase px-10 py-4 rounded-sm hover:bg-white/[0.06] hover:border-white/50 transition-colors"
          >
            Falar com especialista
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-6 h-6 text-white/40" />
      </div>
    </section>
  );
};

export default HeroSection;
